import { render, staticRenderFns } from "./copy-price-from.vue?vue&type=template&id=1ab695f0&"
import script from "./copy-price-from.vue?vue&type=script&lang=js&"
export * from "./copy-price-from.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports